import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id C8A8A7E4-7745-4CA1-A99B-724C2471CAF5
 * name plus-minus-box
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-minus-box.svg
 * tags
 * - Math 
 */
export const PlusMinusBoxIcon = createSvgIcon(<><path d="M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5M11,6H13V9H16V11H13V14H11V11H8V9H11V6M8,16H16V18H8V16Z" /></>, 'PlusMinusBoxIcon');
export default PlusMinusBoxIcon